"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _system = require("@mui/system");
var _theme = require("../theme");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * 
 * @returns 
 */
var ModalFilePreview = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var customStyle = props.customStyle;
  var StyledDiv = (0, _system.styled)('div')(function (_ref) {
    var theme = _ref.theme;
    return _objectSpread((0, _defineProperty2["default"])({
      minHeight: '315px',
      minWidth: '285px',
      backgroundColor: _theme.colors.surface,
      borderRadius: '8px',
      padding: '10px',
      marginLeft: '5px',
      margin: '5px',
      wordBreak: 'break-all'
    }, theme.breakpoints.down('666'), {
      minWidth: 'fit-content'
    }), customStyle);
  });
  var children = props.children;
  return /*#__PURE__*/_react["default"].createElement(StyledDiv, props, children);
});
var _default = exports["default"] = ModalFilePreview;